(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider'];

    function stateConfig($stateProvider, $stickyStateProvider) {
        $stateProvider
            .state('lot', {
                parent: 'app',
                url: '/lot',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_LOTS','ROLE_JPN'],
                    pageTitle: 'ccsTrApp.lot.home.title',
                    title: 'Lot'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lot/lots.html',
                        controller: 'LotController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('lotStatus');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('lot.all', {
                parent: 'app',
                url: '/lot/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_LOTS','ROLE_JPN','ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.lot.home.title',
                    title: 'All'
                },
                views: {
                    'lot-all@': {
                        templateUrl: 'app/entities/lot/lots.html',
                        controller: 'LotController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function() {
                        return {

                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('lotStatus');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('lot.lot-detail', {
                parent: 'app',
                url: '/lot/{id}/detail',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_LOTS','ROLE_JPN','ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.lot.detail.title',
                    title: "Detail"
                },
                views: {
                    'lot-detail@': {
                        templateUrl: 'app/entities/lot/lot-detail.html',
                        controller: 'LotDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('lotStatus');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'LotDTO', function($stateParams, $state, LotDTO) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return LotDTO.get({id : paramId}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'lot',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('lot.new', {
                parent: 'app',
                url: '/lot/new',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_LOTS'],
                    pageTitle: 'New Lot',
                    title: 'New'
                },
                views: {
                    'lot-new@': {
                        controller: 'LotDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/lot/lot-dialog.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: "user",
                            modifiedOn: new Date(),
                            modifiedBy: "user",
                            lotRef: "LOT." + new Date().getTime(),
                            farmRef: null,
                            ginRef: null,
                            lotStatus: null,
                            loadingDate: null,
                            loadingPeriod: null,
                            loadingPlace: null,
                            loadingWarehouse: null,
                            destPlace: null,
                            destWarehouse: null,
                            qtyBales: 0,
                            qtyUnitType: null,
                            cropYear: null,
                            purchase: null,
                            purchPriceUnit: null,
                            purchPrice: 0,
                            purchWtType: "KG",
                            purchGrossKgs: 0,
                            purchNetKgs: 0,
                            purchTareKgs: 0,
                            purchGrossLbs: 0,
                            purchNetLbs: 0,
                            purchTareLbs: 0,
                            purchGrossMTs: 0,
                            purchNetMTs: 0,
                            purchTareMTs: 0,
                            purchLandedGrossKgs: 0,
                            purchLandedNetKgs: 0,
                            purchLandedTareKgs: 0,
                            purchLandedGrossLbs: 0,
                            purchLandedNetLbs: 0,
                            purchLandedTareLbs: 0,
                            purchLandedGrossMTs: 0,
                            purchLandedNetMTs: 0,
                            purchLandedTareMTs: 0,
                            purchValue: 0,
                            interPriceUnit: null,
                            interPrice: 0,
                            interWtType: null,
                            interGrossKgs: 0,
                            interNetKgs: 0,
                            interTareKgs: 0,
                            interGrossLbs: 0,
                            interNetLbs: 0,
                            interTareLbs: 0,
                            interGrossMTs: 0,
                            interNetMTs: 0,
                            interTareMTs: 0,
                            interLandedGrossKgs: 0,
                            interLandedNetKgs: 0,
                            interLandedTareKgs: 0,
                            interLandedGrossLbs: 0,
                            interLandedNetLbs: 0,
                            interLandedTareLbs: 0,
                            interLandedGrossMTs: 0,
                            interLandedNetMTs: 0,
                            interLandedTareMTs: 0,
                            interValue: 0,
                            allocSale: null,
                            allocSi: null,
                            salePriceUnit: null,
                            salePrice: 0,
                            saleFinalPrice: 0,
                            saleWtType: null,
                            saleGrossKgs: 0,
                            saleNetKgs: 0,
                            saleTareKgs: 0,
                            saleGrossLbs: 0,
                            saleNetLbs: 0,
                            saleTareLbs: 0,
                            saleGrossMTs: 0,
                            saleNetMTs: 0,
                            saleTareMTs: 0,
                            saleLandedGrossKgs: 0,
                            saleLandedNetKgs: 0,
                            saleLandedTareKgs: 0,
                            saleLandedGrossLbs: 0,
                            saleLandedNetLbs: 0,
                            saleLandedTareLbs: 0,
                            saleLandedGrossMTs: 0,
                            saleLandedNetMTs: 0,
                            saleLandedTareMTs: 0,
                            saleValue: 0,
                            landedValue: 0,
                            invoiceValue: 0,
                            actualWtAvg: 0,
                            landedWtAvg: 0,
                            actualWtGrossAvg: 0,
                            landedWtGrossAvg: 0,
                            actualWtTareAvg: 0,
                            landedWtTareAvg: 0,
                            lotType: null,
                            lotMic: null,
                            lotLen: null,
                            lotStr: null,
                            lotRdb: null,
                            lotSfi: null,
                            origin: null,
                            producer: null,
                            placeOfTakeUp: null,
                            takeUpNr: null,
                            imported: false,
                            growth: null,
                            seller: null,
                            id: null
                        };
                    }
                }
            })
            .state('lot.edit', {
                parent: 'app',
                url: '/lot/{id}/edit',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_LOTS'],
                    pageTitle: 'ccsTrApp.lot.edit',
                    title: 'Edit'
                },
                views: {
                    'lot-edit@': {
                        controller: 'LotDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/lot/lot-dialog.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'Lot', function($stateParams, $state, Lot ) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return Lot.get({id: paramId}).$promise;
                    }]
                }, params: {
                    activeTab: null
                }
            })
            .state('lot.import', {
                parent: 'app',
                url: '/lot/import',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_LOTS'],
                    pageTitle: 'ccsTrApp.lot.import',
                    title: 'Import'
                },
                views: {
                    'lot-import@': {
                        controller: 'LotImportDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/lot/lot-import-dialog.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('lot.delete', {
                parent: 'app',
                url: '/lot/{id}/delete',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_LOTS'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/lot/lot-delete-dialog.html',
                        controller: 'LotDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Lot', function(Lot) {
                                return Lot.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('lot', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });

        $stickyStateProvider.enableDebug( true );
    }
})();
